<template>
  <div>
    <article class="service-support">
      <div class="support-top">
        <h3 id="support-service">服务支持</h3>
        <span></span>
      </div>
      <span class="support-text">
        标准化服务支持源自开发技术与平台多样性的积累
      </span>
      <div class="support-content clearfix">
        <div class="content" v-for="list in productList" :key="list.id">
          <div class="content-top">
            <img :src="list.img" />
          </div>
          <div class="content-center">
            <span class="desc">{{ list.desc }}</span>
          </div>
          <div class="content-bottom">
            <span class="desc1">{{ list.desc1 }}</span>
          </div>
        </div>
      </div>
    </article>
    <article class="service-add">
      <div class="add">
        <div class="add-top">
          <h3>八大增值服务</h3>
          <span></span>
        </div>
        <span class="add-text">
          满足个性化的客户需求是我们义不容辞的义务
        </span>
        <div class="add-content clearfix">
          <address class="content-left">
            <img src="../../static/images/service/tu.png" />
          </address>
          <address class="content-right">
            <div class="right-item">
              <img src="../../static/images/service/chanpin.png" />
              <span>产品策划</span>
            </div>
            <div class="right-item">
              <img src="../../static/images/service/yidyiyi.png" />
              <span>提供一对一网络营销推广培训服务</span>
            </div>
            <div class="right-item">
              <img src="../../static/images/service/it.png" />
              <span>IT架构分析</span>
            </div>
            <div class="right-item">
              <img src="../../static/images/service/fuwuqi.png" />
              <span>专业服务器运维</span>
            </div>
            <div class="right-item">
              <img src="../../static/images/service/liucheng.png" />
              <span>流程优化</span>
            </div>
            <div class="right-item">
              <img src="../../static/images/service/shangjia.png" />
              <span>微信/APP上架指导</span>
            </div>
            <div class="right-item">
              <img src="../../static/images/service/zixun.png" />
              <span>运营咨询服务</span>
            </div>
            <div class="right-item">
              <img src="../../static/images/service/disanfang.png" />
              <span>第三方服务商推荐</span>
            </div>
          </address>
        </div>
      </div>
    </article>
    <home-advisory></home-advisory>
  </div>
</template>
<script>
import HomeAdvisory from "@/components/pc/HomeAdvisory";
export default {
  name: "serviceCenter",
  data() {
    return {
      productList: [
        {
          id: 0,
          img: require("../../static/images/service/diaoyan.png"),
          desc: "需求调研分析",
          desc1: "快速建立起行业& 企业需求调研分析体系，合理运用技术工具帮助客户明确业务目标和技术实现需求",
        },
        {
          id: 1,
          img: require("../../static/images/service/chuangxin.png"),
          desc: "信息化管理方案创新",
          desc1: "沉淀行业知识经验、实践企业信息化管理，创新出更适合客户企业情况IT治理方法和优化方案",
        },
        {
          id: 2,
          img: require("../../static/images/service/jiagou.png"),
          desc: "系统生命力架构设计",
          desc1: "简化复杂的业务逻辑和需求，搭建系统实现的核心框架，确保系统具有高维护性/扩展性/集成性",
        },
        {
          id: 3,
          img: require("../../static/images/service/kaifa.png"),
          desc: "敏捷模式开发流程",
          desc1: "遵循需求不断完善、测试驱动开发等原则，采用迭代开发流程，为企业带来超预期产品",
        },
        {
          id: 4,
          img: require("../../static/images/service/guanli.png"),
          desc: "项目质量管理体制",
          desc1: "策划可行的质量管控活动，正确地执行和控制这些活动以保证绝大多数缺陷在开发过程中被识别并消除",
        },
        {
          id: 5,
          img: require("../../static/images/service/zujianhua.png"),
          desc: "组件化软件开发技术平台",
          desc1: "在自主研发的软件开发平台上高效率低成本地扩展新功能、配置新流程，灵活快速地促进IT与业务融合",
        },
        {
          id: 6,
          img: require("../../static/images/service/goutong.png"),
          desc: "项目沟通-交付体系",
          desc1: "建立起内外部双方密切互动的项目沟通平台，确保需求传递和实现一致性，为客户规避软件外包风险",
        },
        {
          id: 7,
          img: require("../../static/images/service/xinxihua.png"),
          desc: "信息化实施成效档案",
          desc1: "关注企业客户信息化实施后的目标绩效情况，持续帮助客户改进软件系统使用效果，发展企业竞争优势",
        }
      ],

    }
  },
  mounted() {

  },
  methods: {

  },
  components: {
    HomeAdvisory,
  }
}
</script>
<style lang="stylus" scoped>
.clearfix:before, .clearfix:after {
  content: '';
  display: table;
  clear: both;
}

div {
  color: #333333;
}

.service-support {
  width: 1400px;
  margin: 80px auto;
  text-align: center;

  .support-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .support-top span {
    display: block;
    margin: 20px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .support-text {
    display: inline-block;
    font-size: 16px;
    margin-top: 20px;
  }

  .support-content {
    justify-content: center;
    align-items: center;
    justify-items: center;
    margin-top: 34px;

    .content {
      width: 332px;
      height: 329px;
      float: left;
      margin-left: 24px;
      margin-top: 24px;
      border: 1px solid #F3F3F3;
      box-sizing: border-box;
      box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
      border-radius: 4px;
      transition: all .3s;

      .content-top {
        margin-top: 48px;
      }

      .content-center {
        font-size: 18px;
        margin-top: 38px;
        font-weight: bold;
      }

      .content-bottom {
        margin: 15px auto;
        padding: 0 48px;
        font-size: 14px;
        line-height: 30px;
      }
    }

    .content:hover {
      transform: scale(1.05, 1.05);
      box-shadow: 0px 5px 17px 3px rgba(230, 192, 76, 0.15);
    }

    .content:first-child, .content:nth-child(5), .content:nth-child(9) {
      margin-left: 0;
    }
  }
}

.service-add {
  width: 100%;
  padding: 80px 0;
  margin: 80px auto;
  margin-bottom: 132px;
  background-color: #F5F5F5;
  text-align: center;

  .add {
    width: 1400px;
    margin: 0 auto;
  }

  .add-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .add-top span {
    display: block;
    margin: 20px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .add-text {
    display: inline-block;
    font-size: 16px;
    margin-top: 20px;
  }

  .add-content {
    margin-top: 59px;

    .content-left {
      width: 538px;
      float: left;
    }

    .content-right {
      width: 862px;
      float: left;

      .right-item {
        float: left;
        width: 407px;
        height: 104px;
        background: #FFFFFF;
        border-radius: 4px;
        margin-left: 24px;
        margin-bottom: 24px;
        box-sizing: border-box;
        transition: all .3s;

        img {
          float: left;
          margin: 31px 19px 32px 32px;
        }

        span {
          float: left;
          line-height: 104px;
          font-size: 18px;
        }
      }

      .right-item:hover {
        transform: translateY(-10px);
        box-shadow: 0px 5px 17px 3px rgba(230, 192, 76, 0.15);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/ServiceCenter.vue